import * as types from '../actionTypes/client'

let defaultState = {
  lobbyistClients: [],
  currentClient: {}
}

const clientReducer = (state = defaultState, action) => {
  if (action.type === types.GET_CLIENT) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.client) {
      action.client = {}
    } else {
      action.client = {
        ...action.client,
        // convert dates into date objects before putting into store so they can be treated properly without needing to convert later
        StartDate: action.client.StartDate ? new Date(action.client.StartDate) : null,
        EndDate: action.client.EndDate ? new Date(action.client.EndDate) : null
      }
    }
    return {
      ...state,
      currentClient: action.client
    }
  }
  else if (action.type === types.GET_CLIENT_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistClients: action.lobbyistClients
    }
  }
  else if (action.type === types.UPDATE_CLIENT_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistClients: state.lobbyistClients.map(lobbyistClient => {
        return lobbyistClient.ClientId === action.lobbyistClient.ClientId ?
          {
            ...action.lobbyistClient
          } :
          {
            ...lobbyistClient
          }
      })
    }
  }
  else if (action.type === types.ADD_CLIENT_TO_LOBBYIST) {
    return {
      ...state,
      lobbyistClients: state.lobbyistClients.concat({
        ...action.lobbyistClient
      })
    }
  }
  else if (action.type === types.REMOVE_CLIENT_FROM_LOBBYIST) {
    return {
      ...state,
      lobbyistClients: state.lobbyistClients.filter(client => client.ClientId !== action.clientId)
    }
  }
  else if (action.type === types.CLEAR_CLIENT) {
    return {
      ...state,
      currentClient: {}
    }
  }
  else if (action.type === types.CLEAR_CLIENTS_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistClients: []
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default clientReducer;


// WEBPACK FOOTER //
// ./src/reducers/client.js